module.exports = __webpack_public_path__ + "static/media/mobile_icon.89f6c869.png";